import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import PATHS from "../paths";

import useUserState, { UserState } from "@/hooks/useUserState.tsx";

export type ProtectedRouteProps = {
  accessFor: UserState[] | "all";
  children: ReactNode;
};

const ProtectedRoute = ({ accessFor, children }: ProtectedRouteProps) => {
  const userState = useUserState();

  console.log("userState", userState);
  if (accessFor === "all") return children;

  if (accessFor.some((state) => state === userState)) {
    return children;
  }

  return <Navigate to={PATHS.REDIRECT} />;
};

export default ProtectedRoute;
